module.exports = __webpack_public_path__ + "static/img/toujiao66.1a82dac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao66.jpg
// module id = c7ej
// module chunks = 1